import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'ckeditor5/ckeditor5.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import ThemeContext from "./context/ThemeContext";
import GoogleMapsProvider from "./GoogleMapsProvider";
// import { SocketProvider } from "./context/SocketContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename='/'>
        <ThemeContext>
          {/* <SocketProvider> */}
            {/* <GoogleMapsProvider> */}
            <App />
          {/* </SocketProvider> */}
          {/* </GoogleMapsProvider> */}
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
